import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { useScrollTrigger, Fab, Zoom } from "@material-ui/core";
import KeyboardArrowUpIcon from "@material-ui/icons/KeyboardArrowUp";

const AccessibilityTooltip = React.lazy(() => import("./AccessibilityTooltip"));

const useStyles = makeStyles((theme) => ({
    root: {
        position: "fixed",
        bottom: theme.spacing(2),
        right: theme.spacing(2),
    },
    button: {
        "&:focus-visible": {
            outline: "#000 auto 2px",
            outlineOffset: 3,
        },
    },
}));

const ScrollTop = (props) => {
    const classes = useStyles();

    const { window: win } = props;
    const trigger = useScrollTrigger({
        target: win ? window() : undefined,
        disableHysteresis: true,
        threshold: 100,
    });

    const handleClick = (event) => {
        // return
        const anchor = (event.target.ownerDocument || document).querySelector("#back-to-top-anchor");

        if (anchor) {
            window.scrollTo({ top: 0, behavior: "smooth" });
            // anchor.scrollIntoView({ behavior: 'smooth', block: 'center' });
        }
    };

    return (
        <Zoom in={trigger}>
            <div onClick={handleClick} role="presentation" className={classes.root}>
                <AccessibilityTooltip arrow={false} placement="top-end" title={`Powróć na początek strony`}>
                    <Fab
                        color="primary"
                        aria-label="Powróć na początek strony"
                        size={"medium"}
                        className={classes.button}
                        disableRipple
                    >
                        <KeyboardArrowUpIcon />
                    </Fab>
                </AccessibilityTooltip>
            </div>
        </Zoom>
    );
};

export default ScrollTop;
